import classnames from 'classnames';
import styles from './styles.module.sass';
import React from 'react';

interface SpinnerProps extends React.HTMLAttributes<HTMLDivElement> {
    block?: boolean;
    inline?: boolean;
    isAutoHeight?: boolean;
    swiper?: boolean;
    rainbow?: boolean;
    /**
     * Opaque overlay background to obscure content behind spinner
     */
    opaqueBg?: boolean;
}

export const Spinner = ({
    block = false,
    inline = false,
    isAutoHeight = false,
    swiper = false,
    rainbow = false,
    opaqueBg = false,
    ...props
}: SpinnerProps) => {
    const classNames = classnames(styles.spinner, styles.loading, {
        [styles.block]: block,
        [styles.inline]: inline,
        /**
         * Spinner takes full parent's height; aspect ratio is set to 1/1 so that spinner is square
         */
        [styles.isAutoHeight]: isAutoHeight,
        [styles['swiper-loader']]: swiper,
        [styles.rainbow]: rainbow,
        [styles.opaque]: opaqueBg,
    });

    return (
        <div className={classNames} {...props}>
            {rainbow ? (
                <svg
                    className={styles.spin}
                    width="36px"
                    height="36px"
                    viewBox="0 0 66 66"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <circle
                        className={styles.path}
                        fill="none"
                        strokeWidth="6"
                        strokeLinecap="round"
                        cx="33"
                        cy="33"
                        r="30"
                    ></circle>
                </svg>
            ) : (
                <span>
                    <i />
                </span>
            )}
        </div>
    );
};
